import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Auth } from 'src/app/models/auth';
import { DadoBancarioCedente } from 'src/app/models/dado-bancario-cedente';
import { Overlay } from '@angular/cdk/overlay';
import { DadoBancarioService } from 'src/app/services/dado-bancario.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import * as removeAccents from 'remove-accents';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ChavePixService } from 'src/app/services/chave-pix.service';

@Component({
    selector: 'app-dado-bancario-list',
    templateUrl: './dado-bancario-list.component.html',
    styleUrls: ['./dado-bancario-list.component.css']
})
export class DadoBancarioListComponent implements OnInit {

    //#region Propriedades
    public currentUser: Auth;
    public dadosBancarios: DadoBancarioCedente[];
    public dadosBancariosList: DadoBancarioCedente[];
    public sortOrder: boolean;
    //#endregion

    //#region Filtro
    public filtroBanco: string;
    public filtroAgencia: string;
    public filtroConta: string;
    //#endregion

    //#region Paginação
    public currentPage = 1;
    public showItem = '10';
    //#endregion

    //#region Modal Delete
    public dadoBancarioToDelete: DadoBancarioCedente;
    public deleteCount: number;
    public selectAll: boolean;
    //#endregion
    public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    public cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    public celularMask = ['(',/\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-' ,/\d/, /\d/, /\d/, /\d/];
    public chavePix;
    public tipoChavePix: number;
    public loading = true;

    constructor(
        private dadoBancarioService: DadoBancarioService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private modalService: NgbModal,
        private pixService: ChavePixService,
        private router: Router,
        private route: ActivatedRoute,
        public overlay: Overlay,
        public viewContainerRef: ViewContainerRef) { }


    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.load();

    }

    load(){

        this.pixService.getChavePix(this.currentUser.token.pessoaId).subscribe(res =>{
            if (res.status === 1){
              this.loading = false
              this.chavePix = res.result.pixKey;
              this.tipoChavePix = res.result.keyType;
            }
            else{
                this.loading = false
            }
          });
    }

    loadList() {
        this.dadoBancarioService.getAll(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.dadosBancarios = response.result;
                    this.dadosBancariosList = response.result;
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Ocorreu um erro ao buscar os dados!');
                console.log(error);
            }
        );
    }
    excluirChavePix(){
        this.pixService.deleteChavePix(this.currentUser.token.pessoaId).subscribe(res =>{

          if (res.status === 1){
            this.chavePix = null;
            this.alertService.success('Chave deletada com sucesso');
          }else{
            this.alertService.error(res.message);
          }

        });

      }
    editarChavePix(){
        this.router.navigate(['edit/'], { relativeTo: this.route.parent });
    }

    create() {
        this.router.navigate(['create'], { relativeTo: this.route.parent });
    }

    edit(dadoBancario: DadoBancarioCedente) {
        this.dadoBancarioService.setPossuiConta(this.dadosBancariosList.length <= 1);
        this.router.navigate([`edit/${dadoBancario.dadoBancarioGuid}`], { relativeTo: this.route.parent });
    }

    //#region Filtros

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    realodList() {
        let tempList = this.dadosBancarios;
        if (this.filtroBanco) {
            tempList = tempList.filter(s => removeAccents(s.bancoNome).toLocaleLowerCase().includes(removeAccents(this.filtroBanco).toLocaleLowerCase()));
        }

        if (this.filtroAgencia) {
            tempList = tempList.filter(s => s.agencia.toLocaleLowerCase().includes(this.filtroAgencia.toLocaleLowerCase()));
        }

        if (this.filtroConta) {
            tempList = tempList.filter(s => s.conta.toLocaleLowerCase().includes(this.filtroAgencia.toLocaleLowerCase()));
        }

        this.dadosBancariosList = tempList;
    }

    orderBy(collumnName: string, sortOrder: boolean) {
        this.dadosBancariosList.sort(
            (a, b) => {
                const dftl = sortOrder ? Number.MAX_VALUE : -Number.MAX_VALUE;
                const aVal = (a[collumnName] === null ? dftl : a[collumnName]).toString();
                const bVal = (b[collumnName] === null ? dftl : b[collumnName]).toString();
                let result = aVal.localeCompare(bVal, undefined, { numeric: true });
                if (sortOrder) {
                    result = bVal.localeCompare(aVal, undefined, { numeric: true });
                }
                return result;
            }
        );
    }

    applyFilter(banco: string, agencia: string, conta: string) {
        this.filtroBanco = banco;
        this.filtroAgencia = agencia;
        this.filtroConta = conta;
        this.realodList();
    }

    searchFilter(word: string) {
        if (!word) {
            this.dadosBancariosList = this.dadosBancarios;
        } else {
            word = removeAccents(word).toLocaleLowerCase();
            this.dadosBancariosList = this.dadosBancarios
                .filter(
                    s => removeAccents(s.bancoNome).toLocaleLowerCase().includes(word) ||
                        s.agencia.toLocaleLowerCase().includes(word) ||
                        s.conta.toLocaleLowerCase().includes(word));
        }
    }

    //#endregion

    //#region Delete

    showDelete(content: any, dadoBancario: DadoBancarioCedente) {
        this.dadoBancarioToDelete = dadoBancario;
        this.modalService.open(content, { centered: true, size: 'sm' });
    }

    delete(dadoBancario: DadoBancarioCedente) {
        this.dadoBancarioService.delete(dadoBancario.dadoBancarioGuid, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.alertService.success(response.message);
                    this.loadList();
                    this.realodList();
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Ocorreu um erro ao buscar os dados!');
            }
        );
    }

    updateDeleteCount() {
        this.deleteCount = this.dadosBancariosList.filter(x => x.toDelete).length;
    }

    selectAllToDelete(value: boolean) {
        this.dadosBancariosList.forEach(obj => {
            obj.toDelete = value;
        });
        this.updateDeleteCount();
    }

    showDeleteAll(content: any) {
        this.updateDeleteCount();
        this.modalService.open(content, { centered: true, size: 'sm' });
    }

    deleteAllSelected() {
        this.dadosBancariosList.forEach(obj => {
            if (obj.toDelete) {
                this.delete(obj);
            }
        });
        this.updateDeleteCount();
    }
}
